var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCallList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.00975,
    y: 4.74805,
    width: 14.5027,
    height: 14.5027,
    rx: 3.375,
    stroke: "#3C3C3C",
    strokeWidth: 1.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5438 12.1049L16.5435 10.8417C16.5434 10.47 16.7269 10.1222 17.0339 9.91251L20.2405 7.72172C20.9872 7.21157 22.0001 7.7463 22.0001 8.65063V15.3461C22.0001 16.2505 20.9872 16.7852 20.2405 16.275L17.0339 14.0843C16.727 13.8746 16.5434 13.5268 16.5435 13.1551L16.5438 12.1049Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15088 12.002H11.371",
    stroke: "#3C3C3C",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26102 14.1113L9.26102 9.89117",
    stroke: "#3C3C3C",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallList);
export default __webpack_public_path__ + "static/media/Video_Call_list.be5cb5ff8034b7758bf9af092346ded7.svg";
export { ForwardRef as ReactComponent };